export function remove<T>(arr: T[], condition: (element: T) => boolean): T | null {
  const elementExistsAt = arr.findIndex(condition);
  if (elementExistsAt > -1) {
    const elementToRemove = arr[elementExistsAt];
    arr.splice(elementExistsAt, 1);
    return elementToRemove;
  }
  return null;
}
